import * as React from "react"
import Colors from "../../theme/colors"
import Text from "../text"
import Grid from "../grid"
import Box from "../box"
import styled from "styled-components"

const HeadingH1 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`

interface Props {
  value?: string
}

const SingleListingMoveInBonusesSection = ({ value }: Props) => {
  return (
    <Box flexDirection="column" mb={[4]} mt={[4]}>
      <HeadingH1>Move-in Bonuses</HeadingH1>
      <Grid>
        <Text fontSize={18} color={Colors.darkGrey} lineHeight={1.4}>
          {value}
        </Text>
      </Grid>
    </Box>
  )
}

export default SingleListingMoveInBonusesSection
